import Keycloak from "keycloak-js";

const apiAuthBaseUrl = import.meta.env.VITE_API_AUTH_BASE_URL;
const apiAuthRealm = import.meta.env.VITE_API_AUTH_REALM;
const apiAuthClientId = import.meta.env.VITE_API_AUTH_CLIENT_ID;

const keycloak = new Keycloak({
  realm: apiAuthRealm,
  url: apiAuthBaseUrl,
  clientId: apiAuthClientId,
});

export default keycloak;
